(() => {
  const hotSaleHandles = new Set([
    'still-light-sterling-silver-bezel-moissanite-leverback-drop-earrings',
    'still-light-sterling-silver-bezel-moissanite-huggie-hoop-earrings',
    'still-light-sterling-silver-bezel-moissanite-choker-necklace',
    'flowline-bezel-moissanite-fluid-hoop-earrings',
    'flowline-sculpted-fluid-hoop-earrings',
    'flowline-two-tone-wave-hoop-earrings',
    'solitaire-moissanite-leverback-drop-earrings',
  ]);

  const badgeClass = 'hot-sale-corner-badge';
  const targetClass = 'hot-sale-badge-target';

  function injectStyles() {
    if (document.getElementById('hot-sale-badge-styles')) return;

    const style = document.createElement('style');
    style.id = 'hot-sale-badge-styles';
    style.textContent = `
      .${targetClass} {
        position: relative !important;
      }

      .${badgeClass} {
        position: absolute;
        top: 0;
        right: 0;
        z-index: 5;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        min-width: 116px;
        min-height: 28px;
        padding: 0 16px;
        border: 1px solid rgb(32 29 23 / 0.12);
        background: #f7f3ec;
        color: #221f1a;
        box-shadow: 0 1px 2px rgb(0 0 0 / 0.08);
        font-family: var(--font-body--family, Arial, sans-serif);
        font-size: 11px;
        font-weight: 600;
        letter-spacing: 0.12em;
        line-height: 1;
        text-transform: uppercase;
        pointer-events: none;
      }

      .card-gallery .${badgeClass},
      .resource-card__media .${badgeClass} {
        min-width: 92px;
        min-height: 24px;
        padding-inline: 12px;
        font-size: 10px;
      }

      @media screen and (max-width: 749px) {
        .${badgeClass} {
          min-width: 92px;
          min-height: 24px;
          padding-inline: 12px;
          font-size: 10px;
        }
      }
    `;
    document.head.appendChild(style);
  }

  function getHandleFromUrl(url) {
    try {
      const parsedUrl = new URL(url, window.location.origin);
      const match = parsedUrl.pathname.match(/\/products\/([^/?#]+)/);
      return match ? match[1] : '';
    } catch {
      return '';
    }
  }

  function isHotSaleUrl(url) {
    return hotSaleHandles.has(getHandleFromUrl(url));
  }

  function createBadge() {
    const badge = document.createElement('span');
    badge.className = badgeClass;
    badge.textContent = 'HOT SALE';
    return badge;
  }

  function addBadge(target) {
    if (!target || target.querySelector(`:scope > .${badgeClass}`)) return;

    target.classList.add(targetClass);
    target.appendChild(createBadge());
  }

  function addBadgeToProductPage() {
    if (!isHotSaleUrl(window.location.href)) return;

    const gridFirstMedia = document.querySelector('media-gallery .media-gallery__grid > .product-media-container:first-child');
    if (gridFirstMedia) {
      addBadge(gridFirstMedia);
      return;
    }

    const firstSlide = document.querySelector('media-gallery slideshow-slide:first-child');
    if (firstSlide) {
      addBadge(firstSlide);
      return;
    }

    const firstMediaContainer = document.querySelector('media-gallery .product-media-container');
    if (firstMediaContainer) {
      addBadge(firstMediaContainer);
      return;
    }

    const firstProductMedia = document.querySelector('media-gallery .product-media');
    addBadge(firstProductMedia);
  }

  function addBadgeToProductCards() {
    for (const link of document.querySelectorAll('a[href*="/products/"]')) {
      if (!isHotSaleUrl(link.href)) continue;

      const cardGallery = link.closest('.card-gallery');
      if (cardGallery) {
        const firstSlide = cardGallery.querySelector('slideshow-slide:first-child');
        addBadge(firstSlide || cardGallery);
      }

      const resourceCard = link.closest('.resource-card');
      if (resourceCard) {
        addBadge(resourceCard.querySelector('.resource-card__media'));
      }
    }
  }

  function applyBadges() {
    injectStyles();
    addBadgeToProductPage();
    addBadgeToProductCards();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyBadges, { once: true });
  } else {
    applyBadges();
  }

  const observer = new MutationObserver(() => {
    window.requestAnimationFrame(applyBadges);
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
